import { RiEyeLine, RiCloseLine } from 'react-icons/ri'
import { storageUrl } from '../../../lib/api.js'
import { formatBytes } from '../../../lib/utils.js'
import { Toggle, Badge } from '../../../components/ui/design.jsx'

export default function ImageCard({ img, onPreview, onToggle, onDelete, atCapacity }) {
  return (
    <div className="group overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-md hover:border-blue-300 transition-all">
      {/* Thumbnail */}
      <div
        className="relative aspect-video cursor-pointer bg-gray-100"
        onClick={() => onPreview(img)}
      >
        <img
          src={storageUrl(img.thumb_url || img.url)}
          alt={img.title || img.original_name}
          className="h-full w-full object-cover"
          onError={(e) => { e.currentTarget.src = storageUrl(img.url) }}
          loading="lazy"
        />
        {/* Hover overlay */}
        <div className="absolute right-2 top-2 inline-flex items-center gap-1 rounded-lg bg-black/60 px-2 py-1 text-xs text-white opacity-0 group-hover:opacity-100 transition-opacity backdrop-blur-sm">
          <RiEyeLine /> Lihat
        </div>
        {img.is_active && (
          <span className="absolute left-2 top-2">
            <Badge variant="active">Aktif</Badge>
          </span>
        )}
      </div>

      {/* Info */}
      <div className="px-4 py-3">
        <div className="text-sm font-semibold text-gray-900 truncate">
          {img.title || img.original_name}
        </div>
        <div className="mt-0.5 text-xs text-gray-400 truncate">
          {img.image_type?.name} · {formatBytes(img.size_bytes)} · #{img.sort_order}
        </div>

        <div className="mt-2 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Toggle
              checked={img.is_active}
              onChange={() => onToggle(img)}
              disabled={atCapacity && !img.is_active}
              size="sm"
            />
            <span className="text-xs text-gray-400">
              {img.is_active ? 'Aktif' : 'Nonaktif'}
            </span>
          </div>
          <button
            onClick={() => onDelete(img)}
            className="rounded-lg p-1.5 text-gray-400 hover:bg-red-50 hover:text-red-600 transition-colors"
            title="Hapus gambar"
            type="button"
          >
            <RiCloseLine />
          </button>
        </div>
      </div>
    </div>
  )
}
